import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import type { GetBrandingV2Request, UpsertMutation } from '@vendasta/protos/partner/v1/types';
import {
  getBranding$,
  getMultiBranding$,
  listBranding$,
  upsertBranding$,
} from '@vendasta/protos/partner/v1/branding-v2service';

@Injectable({ providedIn: 'root' })
export class BrandingV2Service {
  getBranding(partnerId: string, marketId?: string) {
    return getBranding$({ partnerId, marketId }).pipe(map((resp) => resp.branding!));
  }

  getMultiBranding(requests: Partial<GetBrandingV2Request>[]) {
    return getMultiBranding$({ requests }).pipe(map((resp) => resp.branding));
  }

  listBranding(partnerId: string, pageSize: number, cursor: string) {
    return listBranding$({
      partnerId,
      pagingOptions: { pageSize, cursor },
    }).pipe(map((resp) => resp?.brandings));
  }

  upsertBranding(partnerId: string, marketId?: string, mutations?: Partial<UpsertMutation>[]) {
    return upsertBranding$({ partnerId, marketId, mutations }).pipe(map(() => true));
  }
}
